/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../Stages/StagesCase";

export const pendingCaseRequiredFields = {
  [stagesCase.STAGE_COMPLETED]: () => {
    return [];
  },
};
